<div class="technicians-reorder-message">
  {{ 'bikeshop.users.reorder_message' | translate }}
</div>

<div class="flex" *ngIf="!loading">
  <div class="technicians-container" cdkDropList (cdkDropListDropped)="drop($event)">    
    <div *ngFor="let technician of technicians; let i = index;" cdkDrag cdkDragLockAxis="y" class="technician-container">
      <div class="technician-drag">
        <span class="hubtiger-dragdrop"></span>
        <div>
          <avatar size=30 name="{{technician.Name+' '+technician.Surname}}"></avatar>
        </div>
        <div>
          <div>{{technician.Name}} {{technician.Surname}}</div>
          <div class="roles">{{technician.Roles.join(', ')}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
